import fp from 'lodash/fp';

export const getUseDollars = fp.get('csaSummary.useDollars');

export const getFilterDefinitions = state => (
    state.csaSummary.filterDefinitions
);

export const getInitialised = state => (
    state.csaSummary.initialised
);

export const getDefaultFilters = state => (
    state.csaSummary.defaultFilters
);

export const getColumns = state => (
    state.csaSummary.columns
);

export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getDateTo = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.to;
        }
    }
    return null;
};

export const getCsas = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'csa');
        if (filter) {
            return filter.value;
        }
    }
    return [];
};

export const getDefaultSort = state => (
    state.csaSummary.gridSorting
);

export const getCurrentServerFilters = state => state.csaSummary.currentServerFilters;

export const getCurrentClientFilters = state => state.csaSummary.currentClientFilters;
